import {Injectable} from '@angular/core';

export type Primitive = string | number | symbol | Date | boolean;

@Injectable({
    providedIn: 'root'
})
export class FormatStringService {

    dateFormat: string;

    constructor() {
        this.dateFormat = 'YYYY-MM-DDThh:mm:ss.SSZ';
    }

    configDateFormat(format: string) {
        this.dateFormat = format;
    }


    format(text: string, objet: Record<string, Primitive>) {
        if (!text) {
            return '';
        }
        let cpy = text + '';
        Object.entries(objet).forEach(([key, value]) => {
            let value_string;
            switch (typeof value) {
                case 'string':
                    value_string = value;
                    break;
                case 'number':
                    value_string = value + '';
                    break;
                case 'bigint':
                    value_string = value + '';
                    break;
                case 'boolean':
                    value_string = value ? 'true' : 'false';
                    break;
                case 'symbol':
                    value_string = value.toString();
                    break;
                case 'undefined':
                    value_string = 'undefined';
                    break;
                case 'object':
                    if (value instanceof Date) {
                        value_string = this.formatDate(this.dateFormat, value);
                    } else {
                        value_string = '[Object object]';
                    }
                    break;
                default:
                    break;
            }
            cpy = cpy.replace(new RegExp(`{{${this.escapeRegExp(key)}}}`, 'g'), value_string);
        });
        return cpy;
    }

    private escapeRegExp(key: string) {
        return key.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
    }

    private formatDate(format: string, date: Date) {
        return format
            .replace('MM', date.getMonth().toString())
            .replace('YYYY', date.getFullYear().toString())
            .replace('yyyy', date.getFullYear().toString())
            .replace('YY', date.getFullYear().toString().slice(2))
            .replace('yy', date.getFullYear().toString().slice(2))
            .replace('DD', date.getDate().toString())
            .replace('dd', date.getDate().toString())
            .replace('HH', date.getHours().toString())
            .replace('hh', date.getHours().toString())
            .replace('mm', date.getMinutes().toString())
            .replace('ss', date.getSeconds().toString())
            .replace('SS', date.getMilliseconds().toString());
    }
}
